"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
exports.deleteUser = deleteUser;
exports.login = login;
exports.loginSuccessLogic = loginSuccessLogic;
exports.patchUser = patchUser;
exports.postAvatar = postAvatar;
exports.refreshTokenLogic = refreshTokenLogic;
exports.resetPassword = resetPassword;
exports.selectAccount = selectAccount;
exports.setClientIdLogic = setClientIdLogic;
exports.setTokenLogic = setTokenLogic;
var _effects = require("redux-saga/effects");
var _sagas = require("../../utils/sagas");
var _axios = _interopRequireDefault(require("axios"));
var _mimeTypes = _interopRequireDefault(require("mime-types"));
var _path = _interopRequireDefault(require("path"));
var types = _interopRequireWildcard(require("./types"));
var _apis = require("./apis");
var _selectors = require("./selectors");
var _actions = require("../notification/actions");
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var _middlewares = require("../network/middlewares");
var _actions2 = require("./actions");
var _token = require("../../utils/token");
var _api = require("../../utils/api");
var _schemas = require("../users/schemas");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _config = _interopRequireDefault(require("../../config"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
var _manager = _interopRequireDefault(require("../websocket/manager"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var logger = new _logger.default('saga:session');
function setTokenLogic(_ref) {
  var {
    token
  } = _ref;
  return function* () {
    logger.log('setTokenLogic', {
      token
    });
    try {
      var _webSocketManager$get;
      (0, _oldHttpClient.setAxiosToken)(token); // update HTTP requests
      (_webSocketManager$get = _manager.default.getWs('api')) === null || _webSocketManager$get === void 0 || _webSocketManager$get.setToken(token); // websocket token
    } catch (e) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'S11',
        error: e
      }));
    }
  }();
}
function* loginSuccessLogic(data) {
  logger.log('loginSuccessLogic', JSON.stringify(data));
  yield (0, _effects.call)(refreshTokenLogic, data);
  yield (0, _effects.put)((0, _actions2.loginSuccess)(data));
  yield* (0, _api.normalizeApiResponse)([data.user], [_schemas.user]);
}
function* refreshTokenLogic(account) {
  try {
    var _config$session;
    var token = yield (0, _effects.select)(_selectors.userToken);
    var axiosToken = (0, _oldHttpClient.getAxiosProvider)().defaults.headers.common.Authorization;
    if (account !== null && account !== void 0 && account.token) token = account.token;
    if (!((_config$session = _config.default.session) !== null && _config$session !== void 0 && _config$session.isGuest)) {
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      if (!token) {
        logger.warn('refreshTokenLogic: no token found in store', token);
        return;
      }
      if ((0, _token.needRefresh)(token)) {
        // this token will expires in less than 7 days or was generated 7 days ago
        logger.warn('refreshTokenLogic:processing', token);
        var {
          data
        } = yield (0, _effects.call)(_apis.$refreshToken, _client, token);
        logger.warn('refreshTokenLogic:done', data === null || data === void 0 ? void 0 : data.token);
        token = data === null || data === void 0 ? void 0 : data.token;
      }
    }
    if (token && axiosToken !== token) {
      yield (0, _effects.put)((0, _actions2.updateToken)(token));
    }
    return token;
  } catch (e) {
    if ((0, _middlewares.isNetworkError)(e)) return;
    yield (0, _effects.put)((0, _actions.addNotification)({
      message: _i18n.default.translate('default.error'),
      referenceError: 'S1',
      error: e
    }));
    yield (0, _effects.call)(_errorHandler.default.captureException, e);
  } finally {
    if (yield (0, _effects.cancelled)()) logger.warn('refreshTokenLogic:cancelled');
  }
}
function selectAccount(_ref2) {
  var {
    id
  } = _ref2;
  return function* () {
    _callbacks.default.get('analyticsLogEvent')('user_select_account');
    logger.log('selectAccount', {
      id
    });
    var accounts = yield (0, _effects.select)(state => (0, _selectors.sessionSelector)(state).accounts);
    yield (0, _effects.call)(loginSuccessLogic, accounts[id]);
    accounts.forEach((account, index) => {
      if (index === id) return;
      (0, _axios.default)({
        method: 'post',
        url: "".concat(_config.default.apiServerUrl, "/auth/logout"),
        headers: {
          Authorization: account.token
        }
      });
    });
  }();
}
function* login(action) {
  _callbacks.default.get('analyticsLogEvent')('user_login');
  logger.log('login', {
    action
  });
  try {
    var {
      email,
      password
    } = action;
    var _device = yield (0, _effects.call)(_callbacks.default.get('getDeviceId'));
    var {
      data
    } = yield (0, _effects.call)(_apis.$loginRequest, email, password, _device);
    _callbacks.default.get('keyboardDismiss')();
    if (data.length === 1) {
      yield (0, _effects.call)(loginSuccessLogic, data[0]);
    } else {
      yield (0, _effects.put)((0, _actions2.loginChoice)(data));
    }
  } catch (e) {
    var _e$response;
    var responseStatus = e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status;
    var message;
    if ((0, _middlewares.isNetworkError)(e)) {
      message = _i18n.default.translate('network.error.timeout');
    } else if (responseStatus === 401) {
      message = _i18n.default.translate('sagas.login.wrong.label');
    } else if (responseStatus === 403) {
      message = _i18n.default.translate('sagas.login.disabled.account');
    } else {
      var _e$response2;
      var errorCode = e === null || e === void 0 || (_e$response2 = e.response) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.data) === null || _e$response2 === void 0 ? void 0 : _e$response2.code;
      if (errorCode === 'VALIDATION_ERROR') {
        var _e$response3, _attributes$includes;
        var attributes = e === null || e === void 0 || (_e$response3 = e.response) === null || _e$response3 === void 0 || (_e$response3 = _e$response3.data) === null || _e$response3 === void 0 || (_e$response3 = _e$response3.joi) === null || _e$response3 === void 0 || (_e$response3 = _e$response3[0]) === null || _e$response3 === void 0 || (_e$response3 = _e$response3.details) === null || _e$response3 === void 0 || (_e$response3 = _e$response3[0]) === null || _e$response3 === void 0 ? void 0 : _e$response3.path;
        message = _i18n.default.translate('sagas.login.wrong.label');
        if (attributes !== null && attributes !== void 0 && (_attributes$includes = attributes.includes) !== null && _attributes$includes !== void 0 && _attributes$includes.call(attributes, 'email')) {
          message = _i18n.default.translate('sagas.login.email.notValid');
        }
      } else {
        message = _i18n.default.translate('default.error');
      }
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'sagas:session:login');
    }
    if (message) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message,
        referenceError: responseStatus ? "S5-".concat(responseStatus) : 'S5',
        error: e
      }));
      yield (0, _effects.put)((0, _actions2.loginFail)(message));
    }
  }
}
function* postAvatar() {
  _callbacks.default.get('analyticsLogEvent')('user_avatar_post');
  try {
    var pendingAvatar = yield (0, _effects.select)(state => (0, _selectors.sessionSelector)(state).pendingAvatar);
    var data = null;
    if (!pendingAvatar) {
      return;
    }

    // web is object, mobile is string
    if (typeof pendingAvatar === 'object') {
      data = pendingAvatar;
    } else {
      data = {
        file: pendingAvatar,
        filename: _path.default.basename(pendingAvatar),
        type: _mimeTypes.default.lookup(pendingAvatar)
      };
    }
    var _user = yield (0, _effects.select)(_selectors.getUserId);
    var response = yield (0, _effects.call)(_apis.$requestPostAvatar, data, _user);
    yield (0, _effects.call)(_apis.$requestPatchUserAvatar, _user, response);
    yield (0, _effects.put)((0, _actions2.setPendingAvatar)(null));
  } catch (e) {
    var _e$response4;
    var responseStatus = e === null || e === void 0 || (_e$response4 = e.response) === null || _e$response4 === void 0 ? void 0 : _e$response4.status;
    if (responseStatus === 415) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('upload.image.wrong.format')
      }));
    } else {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'S2',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e);
    }
  }
}
function* updateAndPatchUser(action) {
  var {
    key,
    value
  } = action;
  yield (0, _effects.put)((0, _actions2.updateUser)(key, value));
  yield (0, _effects.put)((0, _actions2.requestPatchUser)(key));
  if (key === 'settings' && value.language) {
    yield (0, _effects.call)(_i18n.default.setI18nConfig, value.language);
  }
}
function* patchUser(action) {
  _callbacks.default.get('analyticsLogEvent')('user_patch');
  try {
    var user = yield (0, _effects.select)(_selectors.userSessionSelector);
    var data = {};
    if (!Array.isArray(action.key)) {
      data[action.key] = user[action.key];
    } else {
      action.key.forEach(k => {
        data[k] = user[k];
      });
    }
    var response = yield (0, _effects.call)(_apis.$requestPatchUser, user.id, data);
    yield (0, _effects.put)((0, _actions2.setUser)(response.data));
    yield (0, _effects.put)((0, _actions.addNotification)({
      message: _i18n.default.translate('sagas.profile.success.update'),
      model: response.data
    }));
  } catch (e) {
    yield (0, _effects.put)((0, _actions.addNotification)({
      message: _i18n.default.translate('default.error'),
      referenceError: 'S3',
      error: e
    }));
    yield (0, _effects.call)(_errorHandler.default.captureException, e);
  }
}
function* deleteUser() {
  try {
    var user = yield (0, _effects.select)(_selectors.userSessionSelector);
    yield (0, _effects.call)(_apis.$requestDeleteUser, user.id);
    _callbacks.default.get('analyticsLogEvent')('user_delete');
    yield (0, _effects.put)((0, _actions2.logout)());
  } catch (e) {
    yield (0, _effects.put)((0, _actions.addNotification)({
      message: _i18n.default.translate('default.error'),
      referenceError: 'S4',
      error: e
    }));
    yield (0, _effects.call)(_errorHandler.default.captureException, e);
  }
}
function* requestLogout() {
  _callbacks.default.get('analyticsLogEvent')('user_logout');
  try {
    yield (0, _effects.call)(_apis.$logoutRequest);
    if (_callbacks.default.isExist('logout')) yield _callbacks.default.get('logout')();
  } catch (e) {
    yield (0, _effects.put)((0, _actions.addNotification)({
      message: _i18n.default.translate('sagas.logout.error')
    }));
    yield (0, _effects.call)(_errorHandler.default.captureException, e);
  } finally {
    yield (0, _effects.put)((0, _actions2.purgeSession)());
  }
}
function* resetPassword(action) {
  var {
    email
  } = action;
  try {
    yield (0, _effects.call)(_apis.$resetPasswordRequest, email);
  } catch (e) {
    yield (0, _effects.put)((0, _actions.addNotification)({
      message: _i18n.default.translate('default.error')
    }));
    yield (0, _effects.call)(_errorHandler.default.captureException, e);
  }

  // We don't care, everything is right
  yield (0, _effects.put)((0, _actions.addNotification)({
    message: _i18n.default.translate('sagas.forgotpassword.linkSended')
  }));
}
function putStatusLogic(_ref3) {
  var {
    payload
  } = _ref3;
  return function* () {
    logger.log('putStatusLogic', {
      payload
    });
    var {
      status,
      _user
    } = payload;
    var _me = yield (0, _effects.select)(_selectors.getUserId);
    if (_me === _user) {
      yield (0, _effects.put)((0, _actions2.updateUser)('status', status));
    }
  }();
}
function setClientIdLogic(_ref4) {
  var {
    _client
  } = _ref4;
  return function* () {
    logger.log('setClientIdLogic', {
      _client
    });
    _errorHandler.default.setTag('_client', _client);
    (0, _oldHttpClient.setClientId)(_client);
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _sagas.takeLatest)(types.REQUEST_LOGIN, login), (0, _sagas.takeLatest)(types.REQUEST_LOGIN_SELECT, selectAccount), (0, _sagas.takeEvery)(types.REQUEST_POST_AVATAR, postAvatar), (0, _sagas.takeEvery)(types.REQUEST_PATCH_USER, patchUser), (0, _sagas.takeEvery)(types.UPDATE_AND_PATCH_USER, updateAndPatchUser), (0, _sagas.takeEvery)(types.REQUEST_DELETE_USER, deleteUser), (0, _sagas.takeLatest)(types.REQUEST_LOGOUT, requestLogout), (0, _sagas.takeLatest)(types.REQUEST_REFRESH_TOKEN, refreshTokenLogic), (0, _sagas.takeEvery)(types.FORGOT_PASSWORD_REQUEST, resetPassword),
  // Remove WS_PUT_STATUS from here
  (0, _sagas.takeEvery)('WS_PUT_STATUS', putStatusLogic), (0, _sagas.takeLatest)(types.UPDATE_TOKEN, setTokenLogic), (0, _sagas.takeLatest)(types.SET_CLIENT, setClientIdLogic)]);
}